<div class="container py-5">
    <div class="row">
        <div class="col-lg-6 pe-lg-5 pe-xl-6" appAos>
            <div [innerHTML]="body()?.primary?.heading | renderHtml : headingSerializer"></div>
            <div [innerHTML]="body()?.primary?.slice_title | renderHtml : htmlSerializer"></div>
            <div [innerHTML]="body()?.primary?.slice_description | renderHtml"></div>

            <app-link [link]="body()?.primary?.button_link" [action]="body()?.primary?.button_action" cssClass="btn btn-black mt-4">
                {{ body()?.primary?.button_title }}
            </app-link>
        </div>
        <div class="col-lg-6 mt-5 mt-lg-0">
            <div class="row gy-4 g-md-5">
                @for (benefit of body()?.items; track $index) {
                <div class="col-md-6" appAos>
                    <img [src]="benefit?.icon?.url" [alt]="benefit?.icon?.alt" class="icon-big mb-4" />
                    <div [innerHTML]="benefit?.benefit_title | renderHtml : benefitSerializer"></div>
                    <div [innerHTML]="benefit?.benefit_description | renderHtml"></div>
                </div>
                }
            </div>
        </div>
    </div>
</div>
